var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing;
  return {
    quizShowPadding: spacing.medium,
    sectionWrapperMargin: spacing.xSmall,
    accessCodeWrapperMargin: spacing.xSmall,
    sectionWrapperPadding: spacing.xSmall,
    sectionWrapperPaddingSide: spacing.large
  };
};
export default generateComponentTheme;